module.exports = __webpack_public_path__ + "static/badatel-1588580a532c9ba235d97d110609676f.png";